import { RequestOptionsService } from "./requestOptions";
import request from "request-promise";

export class CompanySettingService {
  public static async getCompanySettings() {
    const options = RequestOptionsService.getBrearerOptions(`companySettings?page=1&limit=500`);
    const result = await request(options);
    return result;
  }
}
